export const PERIOD = {
    SINCE_INCEPTION: new Date(0),
    ONE_YEAR: { years: -1 },
    SIX_MONTHS: { months: -6 },
    THREE_MONTHS: { months: -3 },
};
const QUERY_STATUS_PROPERTIES = [
    'isUninitialized',
    'isLoading',
    'isSuccess',
    'isError',
    'isFetching',
];
export const isQueryResult = (value) => typeof value === 'object' && value != null && QUERY_STATUS_PROPERTIES.some((prop) => value[prop]);
export const QUERY_RESULTS = {
    UNINITIALIZED: {
        isUninitialized: true,
        isLoading: false,
        isSuccess: false,
        isError: false,
        isFetching: false,
    },
    LOADING: {
        isLoading: true,
        isFetching: true,
        isUninitialized: false,
        isError: false,
        isSuccess: false,
    },
    ERROR: (error) => ({
        isUninitialized: false,
        isFetching: false,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error,
    }),
    SUCCESS: (data) => ({
        isUninitialized: false,
        isError: false,
        isFetching: false,
        isLoading: false,
        isSuccess: true,
        data,
    }),
};
export * from './types';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYXBpL2NvbW1vbnMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHO0lBQ3BCLGVBQWUsRUFBRSxJQUFJLElBQUksQ0FBQyxDQUFDLENBQUM7SUFDNUIsUUFBUSxFQUFFLEVBQUUsS0FBSyxFQUFFLENBQUMsQ0FBQyxFQUFFO0lBQ3ZCLFVBQVUsRUFBRSxFQUFFLE1BQU0sRUFBRSxDQUFDLENBQUMsRUFBRTtJQUMxQixZQUFZLEVBQUUsRUFBRSxNQUFNLEVBQUUsQ0FBQyxDQUFDLEVBQUU7Q0FDcEIsQ0FBQztBQUtYLE1BQU0sdUJBQXVCLEdBQUc7SUFDOUIsaUJBQWlCO0lBQ2pCLFdBQVc7SUFDWCxXQUFXO0lBQ1gsU0FBUztJQUNULFlBQVk7Q0FDYixDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLENBQzNCLEtBQWMsRUFDc0MsRUFBRSxDQUN0RCxPQUFPLEtBQUssS0FBSyxRQUFRLElBQUksS0FBSyxJQUFJLElBQUksSUFBSSx1QkFBdUIsQ0FBQyxJQUFJLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO0FBRXBHLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRztJQUMzQixhQUFhLEVBQUU7UUFDYixlQUFlLEVBQUUsSUFBSTtRQUNyQixTQUFTLEVBQUUsS0FBSztRQUNoQixTQUFTLEVBQUUsS0FBSztRQUNoQixPQUFPLEVBQUUsS0FBSztRQUNkLFVBQVUsRUFBRSxLQUFLO0tBQ2xCO0lBRUQsT0FBTyxFQUFFO1FBQ1AsU0FBUyxFQUFFLElBQUk7UUFDZixVQUFVLEVBQUUsSUFBSTtRQUNoQixlQUFlLEVBQUUsS0FBSztRQUN0QixPQUFPLEVBQUUsS0FBSztRQUNkLFNBQVMsRUFBRSxLQUFLO0tBQ2pCO0lBRUQsS0FBSyxFQUFFLENBQUMsS0FBYyxFQUFFLEVBQUUsQ0FDeEIsQ0FBQztRQUNDLGVBQWUsRUFBRSxLQUFLO1FBQ3RCLFVBQVUsRUFBRSxLQUFLO1FBQ2pCLFNBQVMsRUFBRSxLQUFLO1FBQ2hCLFNBQVMsRUFBRSxLQUFLO1FBQ2hCLE9BQU8sRUFBRSxJQUFJO1FBQ2IsS0FBSztLQUNJLENBQUE7SUFFYixPQUFPLEVBQUUsQ0FBSSxJQUFPLEVBQUUsRUFBRSxDQUN0QixDQUFDO1FBQ0MsZUFBZSxFQUFFLEtBQUs7UUFDdEIsT0FBTyxFQUFFLEtBQUs7UUFDZCxVQUFVLEVBQUUsS0FBSztRQUNqQixTQUFTLEVBQUUsS0FBSztRQUNoQixTQUFTLEVBQUUsSUFBSTtRQUNmLElBQUk7S0FDSyxDQUFBO0NBQ0wsQ0FBQztBQUVYLGNBQWMsU0FBUyxDQUFDIn0=